<div class="ca-drawer ca-position-{{ position() }}">
    <div class="ca-drawer-header">
        <ng-content select="[drawer-header]"></ng-content>
        <button mat-icon-button class="ca-button close-button" data-testid="drawer-close-btn" (click)="visible.set(false)">
            <ca-icon icon="cross"></ca-icon>
        </button>
    </div>
    <div class="ca-drawer-top">
        <ng-content select="[drawer-top]"></ng-content>
    </div>
    <div class="ca-drawer-body" [class.ca-drawer-body-bordered]="bodyBordered()">
        <ng-content select="[drawer-body]"></ng-content>
    </div>
    <div class="ca-drawer-footer">
        <ng-content select="[drawer-footer]"></ng-content>
    </div>
</div>
